import Icons from "@grabyo/icon-font";

import { Heading2 } from "../../typography/text";
import type { TooltipPosition, TooltipProps } from "../../tooltip/tooltip";
import Tooltip from "../../tooltip/tooltip";

import { StyledIcon, IconTitleContainer } from "./icon.styles";
import type { ExtractSCProps } from "pages/common/types/ExtractSCProps";

const Icon = (
    props: ExtractSCProps<typeof StyledIcon> & {
        title?: string;
        tooltipProps?: TooltipProps;
        placement?: TooltipPosition;
        as?: string;
        href?: string; //because of as=a
        disabled?: boolean; //TODO: does this even work?
        name?: string; //one of @grabyo/icon-font
    }
) => {
    const {
        title,
        tooltipProps,
        placement = "top",
        as = "i",
        ...iconProps
    } = props;

    let className = `gb-icon-${props.name}`;
    if (props.className) {
        className += ` ${props.className}`;
    }

    const icon = (
        <StyledIcon
            as={as}
            //TODO: tests rely on this ordering of props...
            aria-label={props.name}
            {...iconProps}
            className={className}
        ></StyledIcon>
    );

    return title ? (
        <Tooltip innerHtml={title} position={placement} {...tooltipProps}>
            {icon}
        </Tooltip>
    ) : (
        icon
    );
};

export const IconWithTitle = (
    props: ExtractSCProps<typeof IconTitleContainer> & {
        icon?: string;
        title: string;
        children?: React.ReactNode;
    }
) => (
    <IconTitleContainer {...props}>
        <Heading2>
            {props.icon && <Icon name={props.icon} />}
            {props.title}
        </Heading2>
        {props.children}
    </IconTitleContainer>
);

export default Icon;
